export default __webpack_public_path__ + "static/media/480_business08-jp-web.25053571.png";